export default __webpack_public_path__ + "static/media/marble-popup-leaderboard-img.2a2ba119.jpg";